var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.enable_luckydraw)?_c('FilterAction',{attrs:{"defaultSelected":_vm.filterBy},on:{"change":_vm.fetchLot},model:{value:(_vm.filterBy),callback:function ($$v) {_vm.filterBy=$$v},expression:"filterBy"}}):_vm._e(),_c('List',{class:{ 'my-3': !_vm.enable_luckydraw },attrs:{"items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }